import React, { useState } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    query: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const response = await fetch("http://localhost:8000/api/send-email", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: `${formData.firstName} ${formData.lastName}`,
          email: formData.email,
          subject: "New Contact Form Submission",
          message: formData.query
        })
      });

      if (!response.ok) throw new Error("Failed to send message");

      setSubmitStatus("success");
      setFormData({ firstName: '', lastName: '', email: '', query: '' });
    } catch (error) {
      console.error("Backend Email Error:", error);
      setSubmitStatus("error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-page">
      <section className="contact-hero">
        <div className="container">
          <div className="contact-content">
            <div className="contact-info">
              <h1>Contact Us</h1>
              <div className="contact-section">
                <h3>Follow us on</h3>
                <div className="social-links">
                  <a href="https://www.linkedin.com/company/the-spur-ventures" target="_blank" rel="noreferrer" aria-label="LinkedIn">
                    LinkedIn
                  </a>
                  <span> | </span>
                  <a href="https://www.instagram.com/thespurventures" target="_blank" rel="noreferrer" aria-label="Instagram">
                    Instagram
                  </a>
                </div>
              </div>
              <div className="logos-section">
                <div className="spur-logo">
                  <img
                    src="/images/SpurLogo.png"
                    alt="The Spur"
                    className="spur-logo-image"
                  />
                </div>
                <div className="unl-logo">
                  <img
                    src="/images/UNLLogo.png"
                    alt="University of Nebraska-Lincoln Biological Systems Engineering"
                    className="unl-logo-image"
                  />
                </div>
              </div>
            </div>

            <div className="contact-form-section">
              <h3>Contact form</h3>

              {submitStatus === 'success' && (
                <div className="success-message">
                  Thank you for your message! We'll get back to you soon.
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="error-message">
                  Sorry, there was an error sending your message. Please try again.
                </div>
              )}

              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    disabled={isSubmitting}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="firstName">First Name</label>
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    required
                    disabled={isSubmitting}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="lastName">Last Name</label>
                  <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    required
                    disabled={isSubmitting}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="query">Query</label>
                  <textarea
                    id="query"
                    name="query"
                    rows="4"
                    placeholder="Tell us about your project, question, or how you'd like to get involved..."
                    value={formData.query}
                    onChange={handleChange}
                    required
                    disabled={isSubmitting}
                  />
                </div>
                <button
                  type="submit"
                  className="submit-btn"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Sending...' : 'Send Message'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
